import { useState } from 'react';
import { RiCloseLine } from "react-icons/ri";
import { Col } from "react-bootstrap";
import { ring } from 'ldrs';
import Cookies from "universal-cookie";
import toast from 'react-hot-toast';

/***********************/
/**  AMPLIFY IMPORTS  **/
/***********************/
import { Amplify } from 'aws-amplify';
import amplifyconfig from '../amplifyconfiguration.json';
import { post } from 'aws-amplify/api';

/****************************/
/**  LOCAL/ASSETS IMPORTS  **/
/****************************/
import EditUserModal from './EditUserModal';
import check from '../assets/check.svg'
import edit_icon from "../assets/edit_icon.svg";
import {
    Centered,
    TheModal,
    ModalHeader,
    ModalContent,
    CloseButton,
    ActionRow,
    ConfirmDialogWrapper
} from '../styles/EditUserStyles';


export default function EditUser({ user, setModalOpen, position, fetchRows }){

    const [openEditModal, setOpenEditModal] = useState(false);
    const [loading, setLoading] = useState(false);
    const [confirmDelete, setConfirmDelete] = useState(false);
    const [showConfirmDialog, setShowConfirmDialog] = useState(false);

    ring.register();
    const cookies = new Cookies();
    const token = cookies.get("TOKEN");
    Amplify.configure(amplifyconfig);

    const handleClose = (e) => {
        e.stopPropagation();
        setModalOpen(false);
    }

    const editUser = (e) => {
        e.stopPropagation();
        setOpenEditModal(true);
        document.body.style.overflow = 'hidden';
    };

    const approveUser = async (e) => {
        setLoading(true);
        e.stopPropagation();
        document.body.style.overflow = 'hidden';
        try {
            const register = post({
                apiName: 'UserAPI',
                path: '/user/change-status',
                options: {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                    body: {
                        email: user.email,
                        status: "Active"
                    }
                }
            });

            const { body } = await register.response;
            const res = await body.json();
            console.log(res);
            console.log('Status change POST call succeeded: Active');
            // Send success notification for manual update
            toast.success(`You have successfully verified the user's status`, {
                position: 'top-center',
                duration: 5000,
            });
            document.body.style.overflow = 'unset';
            fetchRows();
        } catch (e) {
            console.log('Registration POST call failed: ', e);
        } finally {
            setLoading(false);
        }
    };

    function ConfirmDialog({ onConfirm }) {
        return (
            <ConfirmDialogWrapper>
                <p>Are you sure you want to suspend this user?</p>
                <div className="actions">
                    <button onClick={() => onConfirm(true)}>Yes</button>
                    <button onClick={() => onConfirm(false)}>No</button>
                </div>
            </ConfirmDialogWrapper>
        );
    }

    const deleteUser = async () => {
        setLoading(true);
        document.body.style.overflow = 'hidden';
        try {
            const register = post({
                apiName: 'UserAPI',
                path: '/user/change-status',
                options: {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                    body: {
                        email: user.email,
                        status: "Denied"
                    }
                }
            });

            const { body } = await register.response;
            const res = await body.json();
            document.body.style.overflow = 'unset';
            console.log('Status change POST call succeeded: Denied');
            // Send success notification for manual update
            toast.success(`You have successfully deleted ${user.email}'s account`, {
                position: 'top-center',
                duration: 5000,
            });
            document.body.style.overflow = 'unset';
            fetchRows();
        } catch (e) {
            console.log('Registration POST call failed: ', e);
        } finally {
            setLoading(false);
            setShowConfirmDialog(false);
        }
    };

    const confirmDeleteHandler = (confirm) => {
        setConfirmDelete(confirm);
        setShowConfirmDialog(false);
        if (confirm) deleteUser();
    };

    return (
        <Centered style={{ top: position.top,
                           left: position.left,
                           position: 'absolute' }}>
            <TheModal>
                <ModalHeader>
                    <CloseButton onClick={(e) => handleClose(e)}>
                        <RiCloseLine style={{height: "15px"}}/>
                    </CloseButton>
                </ModalHeader>
                <ModalContent>
                        { loading ? (
                            <Col style={{height: "132px", width: "186px"}}>
                                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "132px"}}>
                                    <l-ring
                                        size="30"
                                        stroke="5"
                                        bg-opacity="0"
                                        speed="2"
                                        color="#616161"
                                    />
                                </div>
                            </Col>
                        ) : (
                            <Col>
                                <ActionRow onClick={(e) => editUser(e)}>
                                    <Col xs="auto">
                                        <img src={edit_icon} alt="edit" style={{ height: "16px" }} />
                                    </Col>
                                    <Col xs="auto" className="d-flex align-items-center">
                                        <span>Edit User</span>
                                    </Col>
                                </ActionRow>
                                { user.status !== "Active" ? 
                                    (<ActionRow onClick={(e) => approveUser(e)}>
                                        <Col xs="auto">
                                            <img src={check} alt="edit" style={{ height: "16px" }} />
                                        </Col>
                                        <Col xs="auto" className="d-flex align-items-center">
                                            <span>Approve User</span>
                                        </Col>
                                    </ActionRow>) : (<></>)}
                                { user.status !== "Denied" ? 
                                    (<ActionRow onClick={() => setShowConfirmDialog(true)}>
                                        <Col xs="auto">
                                            <RiCloseLine style={{height: "20px"}}/>
                                        </Col>
                                        <Col xs="auto" className="d-flex align-items-center">
                                            <span>Suspend User</span>
                                        </Col>
                                    </ActionRow>) : (<></>)}
                            </Col>
                        )}
                    {openEditModal && <EditUserModal user={user} setOpenEditModal={setOpenEditModal} /> }
                    {showConfirmDialog && <ConfirmDialog onConfirm={confirmDeleteHandler} />}
                </ModalContent>
            </TheModal>
        </Centered>
    )
}